import type { AnchorHTMLAttributes, ReactNode } from "react";
import * as styles from "./Button.css";

type ButtonVariant = "primary" | "secondary" | "dark";

type ButtonProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  children: ReactNode;
  variant?: ButtonVariant;
};

const variants: Record<ButtonVariant, string> = {
  primary: styles.primary,
  secondary: styles.secondary,
  dark: styles.dark
};

export function Button({ children, variant = "primary", ...props }: ButtonProps) {
  return (
    <a className={variants[variant]} {...props}>
      {children}
    </a>
  );
}
